import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router";
import { useFeatureFlags, useFeatureFlagsLoading } from "@/lib/feature-flags";
import { PublicLayout } from "./PublicLayout";

const Avatar3DPage = lazy(() => import("./avatar-3d/Avatar3DPage"));
const AvatarLiveavatarPage = lazy(
  () => import("./avatar-liveavatar/AvatarLiveavatarPage"),
);

function pickFallback(flags: {
  avatars3d: boolean;
  avatarsLiveavatar: boolean;
}): string | null {
  if (flags.avatars3d) return "avatar-3d";
  if (flags.avatarsLiveavatar) return "avatar-liveavatar";
  return null;
}

export function PublicRouter() {
  const flags = useFeatureFlags();
  const flagsLoading = useFeatureFlagsLoading();
  const fallback = pickFallback(flags);

  // Routes are gated on feature flags. Until the flags query resolves all
  // flags read as `false`, so rendering the router early would match only
  // the catch-all and redirect to the dashboard. Wait for flags first.
  if (flagsLoading) {
    return (
      <PublicLayout>
        <Suspense fallback={null}>{null}</Suspense>
      </PublicLayout>
    );
  }

  return (
    <PublicLayout>
      <Suspense fallback={null}>
        <Routes>
          {fallback ? (
            <Route index element={<Navigate to={fallback} replace />} />
          ) : (
            <Route
              index
              element={<Navigate to="/monitoring/dashboard" replace />}
            />
          )}
          {flags.avatars3d && (
            <Route path="avatar-3d" element={<Avatar3DPage />} />
          )}
          {flags.avatarsLiveavatar && (
            <Route
              path="avatar-liveavatar"
              element={<AvatarLiveavatarPage />}
            />
          )}
          {/* Catch-all redirect */}
          <Route
            path="*"
            element={<Navigate to="/monitoring/dashboard" replace />}
          />
        </Routes>
      </Suspense>
    </PublicLayout>
  );
}
